import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';

export function addSchoolEnrolField(args) {
    let params = new URLSearchParams();
    params.append('fieldJson', args.fieldJson);

    return fetch({
        url: 'structure/staterunEnrol/addSchoolEnrolField',
        method: 'post',
        data: params
    });
}

export function getSchoolEnrolFieldList(args = {}) {
    let params = new URLSearchParams();
    if(args.yearNo) {
        params.append('yearNo', args.yearNo);
    }

    return fetch({
        url: 'structure/staterunEnrol/getSchoolEnrolFieldList',
        method: 'post',
        data: params
    });
}

// 获得学校分组设置信息
export function getSchoolGroupSetInfo() {

    return fetch({
        url: 'structure/staterunEnrol/getSchoolGroupSetInfo',
        method: 'post',
    });
}

// 新增分组设置
export function addEnrolGroupSet(args = {}) {
    let params = new URLSearchParams();
    params.append('dataComplete', args.dataComplete);
    params.append('groupNum', args.groupNum);
    params.append('hasPropertyDate', args.hasPropertyDate);
    params.append('parentProperty', args.parentProperty);
    params.append('propertyDate', args.propertyDate);
    params.append('teachingArea', args.teachingArea);
    params.append('realLive', args.realLive);
    params.append('notSingleParent', args.notSingleParent);
    params.append('hasSettleDate', args.hasSettleDate);
    params.append('settleDate', args.settleDate);

    return fetch({
        url: 'structure/staterunEnrol/addEnrolGroupSet',
        method: 'post',
        data: params
    });
}

// 获得通知下的所有分组列表
export function getNoticeGroupList(args = {}) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getNoticeGroupList',
        method: 'post',
        data: params
    });
}

/*获得报名通知下的所有报名学生列表*/
export function getNoticeApplyStuPageList(args = {}) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    params.append('searchVal', args.searchVal);
    params.append('state', args.state);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);

    return fetch({
        url: 'structure/staterunEnrol/getNoticeApplyStuPageList',
        method: 'post',
        data: params
    });
}
/*自动审核（按分组设置分组）*/
export function autoExamineApplyStudents(args = {}) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    return fetch({
        url: 'structure/staterunEnrol/autoExamineApplyStudents',
        method: 'post',
        data: params
    });
}
/*获得群组下报名学生列表*/
export function getGroupApplyStuPageList(args = {}) {
    let params = new URLSearchParams();
    params.append('groupId', args.groupId);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchVal', args.searchVal);
    params.append('state', args.state);
    return fetch({
        url: 'structure/staterunEnrol/getGroupApplyStuPageList',
        method: 'post',
        data: params
    });
}

/*设置分组审批人*/
export function installNoticeGroupExamine(args = {}) {
    let params = new URLSearchParams();
    params.append('groupsJson', args.groupsJson);

    return fetch({
        url: 'structure/staterunEnrol/installNoticeGroupExamine',
        method: 'post',
        data: params
    });
}

/*获得完整分组列表（包含审批人信息）*/
export function getNoticeCompleteGroupList(args = {}) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    return fetch({
        url: 'structure/staterunEnrol/getNoticeCompleteGroupList',
        method: 'post',
        data: params
    });
}

/*yjx加查询学校面试提醒*/
export function getSchoolInterviewInfo(args){
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getSchoolInterviewInfo',
        method: 'post',
        data: params
    });
}
/*yjx新增或修改学校面试模板 */
export function addAndEditSchoolInterviewTemplet(args) {
    let params = new URLSearchParams();
    params.append('content', args.content);
    params.append('isPrint', args.isPrint);
    params.append('id', args.id);
    params.append('noticeId', args.noticeId);
    return fetch({
        url: 'structure/staterunEnrol/addAndEditSchoolInterviewTemplet',
        method: 'post',
        data: params
    });
}

/*yjx新增学校面试时间安排 */
export function addInterviewTimeSet(args) {
    let params = new URLSearchParams();
    params.append('beginNo', args.beginNo);
    params.append('endNo', args.endNo);
    params.append('beginTime', args.beginTime);
    params.append('noticeId', args.noticeId);
    return fetch({
        url: 'structure/staterunEnrol/addInterviewTimeSet',
        method: 'post',
        data: params
    });
}

/*yjx删除面试时间安排 */
export function deleteInterviewTimeSet(args) {
    let params = new URLSearchParams();
    params.append('setId', args.setId);
    return fetch({
        url: 'structure/staterunEnrol/deleteInterviewTimeSet',
        method: 'post',
        data: params
    });
}

/*获取通知列表不分页*/
export function getSchoolEnrolNoticeList(args) {
    let params = new URLSearchParams();
    params.append('searchVal', args.searchVal);
    params.append('state', args.state);
    return fetch({
        url: 'structure/staterunEnrol/getSchoolEnrolNoticeList',
        method: 'post',
        data: params
    });
}

// 发送短信消息（批量发送）
export function batchSendMessage(args) {
    let params = new URLSearchParams();
    params.append('rangeChecked', args.rangeChecked);
    params.append('endScope', args.endScope);
    params.append('groupId', args.groupId);
    params.append('noticeId', args.noticeId);
    params.append('optType', args.optType);
    params.append('sendTarget', args.sendTarget);
    params.append('sendType', args.sendType);
    params.append('startScope', args.startScope);
    params.append('state', args.sendType);
    params.append('tempContent', args.tempContent);
    params.append('tempId', args.tempId);
    params.append('examineCode', args.examineCode);

    return fetch({
        url: 'structure/staterunEnrol/batchSendMessage',
        method: 'post',
        data: params
    });
}


// 发送短信消息（单个发送）
export function singleSendMessage(args) {
    let params = new URLSearchParams();
    params.append('groupId', args.groupId);
    params.append('noticeId', args.noticeId);
    params.append('receiveUser', args.receiveUser);
    params.append('sendType', args.sendType);
    params.append('smsContent', args.smsContent);
    params.append('smsTempId', args.smsTempId);

    return fetch({
        url: 'structure/staterunEnrol/singleSendMessage',
        method: 'post',
        data: params
    });
}

// 获取学校短信模板
export function queryTemplateBySchoolId() {

    return fetch({
        url: 'structure/recruitMessageTemplate/queryTemplateBySchoolId',
        method: 'post',
    });
}



/*意见不一致组二审*/
export function secondExamine(args) {
    let params = new URLSearchParams();
    params.append('examineResult', args.examineResult);
    params.append('examinOptions', args.examinOptions);
    params.append('groupId', args.groupId);
    params.append('noticeId', args.noticeId);
    params.append('studentId', args.studentId);

    return fetch({
        url: 'structure/staterunEnrol/secondExamine',
        method: 'post',
        data: params
    });
}

// 新增窗口设置
export function addStaterunExamineWindowSet(args) {
    let params = new URLSearchParams();
    params.append('windiwSetJson', args.windiwSetJson);

    return fetch({
        url: 'structure/staterunEnrol/addStaterunExamineWindowSet',
        method: 'post',
        data: params
    });
}

// 查询学校的窗口设置列表
export function getSchoolStaterunEnrolWindowSetList() {

    return fetch({
        url: 'structure/staterunEnrol/getSchoolStaterunEnrolWindowSetList',
        method: 'post'
    });
}


// 学生实际居住确认
export function markStuLiveActual(args) {
    let params = new URLSearchParams();
    params.append('liveActual', args.liveActual);
    params.append('liveRemark', args.liveRemark);
    params.append('stuId', args.stuId);

    return fetch({
        url: 'structure/staterunEnrol/markStuLiveActual',
        method: 'post',
        data: params
    });
}
// 获得学生实际居住标注信息
export function getStuLiveActualInfo(stuId) {
    let params = new URLSearchParams();
    params.append('stuId', stuId);
    return fetch({
        url: 'structure/staterunEnrol/getStuLiveActualInfo',
        method: 'post',
        data: params
    });
}

// 导出学生照片为zip文件
export function exportAllStuAndAllPicList(args) {
    const params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    params.append('state', args.state);

    return fetch({
        url: 'structure/staterunEnrol/exportAllStuAndAllPicList',
        method: 'post',
        data: params
    });
}
// 通知窗口设置信息
export function getNoticeWindowInfo(args) {
    const params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getNoticeWindowInfo',
        method: 'post',
        data: params
    });
}

// 保存通知窗口信息
export function saveNoticeWindowInfo(args) {
    const params = new URLSearchParams();
    params.append('closeTime', args.closeTime);
    params.append('noticeId', args.noticeId);
    params.append('openTime', args.openTime);
    params.append('remarkOne', args.remarkOne);
    params.append('remarkTwo', args.remarkTwo);
    params.append('windowNosJson', args.windowNosJson);

    return fetch({
        url: 'structure/staterunEnrol/saveNoticeWindowInfo',
        method: 'post',
        data: params
    });
}

// 根据ID删除窗口
export function deleteWindowNoById(args) {
    const params = new URLSearchParams();
    params.append('windowId', args.windowId);

    return fetch({
        url: 'structure/staterunEnrol/deleteWindowNoById',
        method: 'post',
        data: params
    });
}

// 查询招生学生状态列表

export function getNoticeStuStateList(args) {
    const params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getNoticeStuStateList',
        method: 'post',
        data: params
    });
}

export function copyBeforeFieldSetInfo() {
    return fetch({
        url: 'structure/staterunEnrol/copyBeforeFieldSetInfo',
        method: 'post',
    });

}
export function copyBeforeWindowSetInfo(args) {
    const params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    return fetch({
        url: 'structure/staterunEnrol/copyBeforeWindowSetInfo',
        method: 'post',
        data: params
    });

}



// WEBPACK FOOTER //
// ./src/api/primary/setting.js